import styled from 'styled-components';
import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Loader = styled(LoaderLayoutComponent)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 200px 100px 250px;
  margin-top: 80px;
  ${({ center }) => (center ? 'align-items: center;' : '') }
`;

const HorizontalContent = styled.div`
    display: flex;
    justify-content: space-between;
`;

const ButtonGroup = styled(ButtonLayoutComponent)`
  height: 40px;
`;

const Text = styled(TextLayoutComponent.Header)`
  margin-bottom: 10px;
`;

const Link = styled.a``;

const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;

export {
  Container,
  HorizontalContent,
  ButtonGroup,
  Text,
  Link,
  ContainerText,
  Loader,
};
